import ExcelAnalytics from './ExcelAnalytics'
const ExcelAnalyticsIndex = () => {
  return (
    <div>
      <ExcelAnalytics />
    </div>
  )
}
export default ExcelAnalyticsIndex
